<template>
  <div class="open-shop" v-if="isShow">
    <div class="step">
      <div class="number">
        <div :class="{'active': stepZero.complete}" @click.stop="goTab('stepZero')">0</div>
        <div :class="{'active': stepZero.complete && stepOne.complete}"></div>
        <div :class="{'active': stepOne.complete}" @click.stop="goTab('stepOne')">1</div>
        <div :class="{'active': stepOne.complete && stepTwo.complete}"></div>
        <div :class="{'active': stepTwo.complete}" @click.stop="goTab('stepTwo')">2</div>
        <div :class="{'active': stepTwo.complete && stepThree.complete}"></div>
        <div :class="{'active': stepThree.complete}" @click.stop="goTab('stepThree')">3</div>
        <div :class="{'active': stepThree.complete && stepFour.complete}"></div>
        <div :class="{'active': stepFour.complete}">4</div>
        <div :class="{'active': stepFour.complete}"></div>
        <div :class="{'active': stepFour.complete}">5</div>
      </div>
      <div class="text">
        <div :class="{'active': stepZero.active}">{{$t('openShop.选择套餐')}}</div>
        <div :class="{'active': stepOne.active}">{{$t('openShop.选择模板')}}</div>
        <div :class="{'active': stepTwo.active}">{{$t('openShop.选择支付渠道')}}</div>
        <div :class="{'active': stepThree.active}">{{$t('openShop.选择商品')}}</div>
        <div :class="{'active': stepFour.active}">{{$t('openShop.结算')}}</div>
        <div :class="{'active': stepFive.active}">{{$t('openShop.成功提交')}}</div>
      </div>
    </div>
  </div>
  <div class="open-shop" v-else>
    <div class="nav-wrap">
      <logo></logo>
      <navbar></navbar>
    </div>
    <div class="step">
      <div class="number">
        <div :class="{'active': stepZero.complete}" @click="goTab('stepZero')">1</div>
        <div :class="{'active': stepZero.complete && stepOne.complete}"></div>
        <div :class="{'active': stepOne.complete}" @click="goTab('stepOne')">2</div>
        <div :class="{'active': stepOne.complete && stepTwo.complete}"></div>
        <div :class="{'active': stepTwo.complete}" @click="goTab('stepTwo')">3</div>
        <div :class="{'active': stepTwo.complete && stepThree.complete}"></div>
        <div :class="{'active': stepThree.complete}" @click="goTab('stepThree')">4</div>
        <div :class="{'active': stepThree.complete && stepFour.complete}"></div>
        <div :class="{'active': stepFour.complete}">5</div>
        <div :class="{'active': stepFour.complete}"></div>
        <div :class="{'active': stepFour.complete}">6</div>
      </div>
      <div class="text">
        <div :class="{'active': stepZero.active}">{{$t('openShop.选择套餐')}}</div>
        <div :class="{'active': stepOne.active}">{{$t('openShop.选择模板')}}</div>
        <div :class="{'active': stepTwo.active}">{{$t('openShop.选择支付渠道')}}</div>
        <div :class="{'active': stepThree.active}">{{$t('openShop.选择商品')}}</div>
        <div :class="{'active': stepFour.active}">{{$t('openShop.结算')}}</div>
        <div :class="{'active': stepFive.active}">{{$t('openShop.成功提交')}}</div>
      </div>
    </div>
    <div class="step-0" v-if="stepZero.active">
       <!-- response for step1 -->
      <el-radio-group v-model="stepZero.result">
        <el-radio :label="value.member_plan_id" v-for="value in stepZero.data" :key="value.member_plan_id"
        >
          <div class="panel checked-box">
            <div class="top-img">
              <div style="color:white;font-size:2rem">{{value.member_plan_name}}</div>
              <div style="color:white;font-size:3rem;font-weight:bold"><span style="font-size:1.5rem">$ </span>{{generatePrice(value.member_plan_price)}}</div>
              <div style="color:white;font: bold 0.5rem;">Per Month + GST</div>
            </div>
            <div class="content">
              <div v-html="value.member_plan_desc"></div>
            </div>
          </div>
        </el-radio>
      </el-radio-group>
      <!-- <el-checkbox-group v-model="stepOne.result">
        <el-checkbox :label="value.template_id" v-for="value in stepOne.data" :key="value.template_id">
          <div class="panel checked-box">
            <div class="text-1">{{value.template_name}}</div>
            <el-image :src="value.template_image[0]" fit="cover"></el-image>
            <div class="text-2">
              <span>{{value.template_desc}}</span>
            </div>
            <div class="imgs">
              <el-image v-for="x in value.template_image" :key="x" :src="x" fit="cover"></el-image>
            </div>
            <div class="bottom">
              <div>{{$t('openShop.订阅费')}}</div>
              <div>NZD ${{(value.template_price / 100).toFixed(2)}}</div>
            </div>
          </div>
        </el-checkbox>
      </el-checkbox-group> -->
      <el-button @click="stepZeroSubmit" :loading="stepZero.loading">{{$t('openShop.确定')}}</el-button>
    </div>
    <div class="step-1" v-if="stepOne.active">
       <!-- response for step2 -->
      <el-radio-group v-model="stepOne.result">
        <el-radio :label="value.template_id" v-for="value in stepOne.data" :key="value.template_id">
          <div class="panel checked-box">
            <div class="text-1">{{value.template_name}}</div>
            <el-image :src="value.template_image[0]" fit="cover"></el-image>
            <div class="text-2">
              <span>{{value.template_desc}}</span>
            </div>
            <div class="imgs">
              <el-image v-for="x in value.template_image" :key="x" :src="x" fit="cover"></el-image>
            </div>
            <div class="bottom">
              <div>{{$t('openShop.订阅费')}}</div>
              <div>NZD ${{(value.template_price / 100).toFixed(2)}}</div>
            </div>
          </div>
        </el-radio>
      </el-radio-group>
      <el-button @click="stepOneSubmit" :loading="stepOne.loading">{{$t('openShop.确定')}}</el-button>
    </div>
    <div class="step-2" v-if="stepTwo.active">
      <el-checkbox-group v-model="stepTwo.result">
        <el-checkbox :label="value.shop_payment_id" v-for="value in stepTwo.data" :key="value.shop_payment_id">
          <div class="panel">
            <el-image class="checked-box" :src="value.shop_payment_icon" fit="cover"></el-image>
            <div class="title">{{value.shop_payment_name}}</div>
            <!-- <div class="title" v-if="value.shop_payment_type === 'IEPAY'">NZD ${{(value.shop_payment_price / 100).toFixed(2)}}</div> -->
            <!-- remove price -->
            <el-button type="success" size="mini" @click="openDialog_4(value)">{{$t('openShop.配置说明')}}</el-button>
            <template v-if="value.shop_payment_type === 'IEPAY'">
              <el-input placeholder="Mid" v-model="stepTwo.iePay.mid" size="medium"></el-input>
              <el-input placeholder="Api Key" v-model="stepTwo.iePay.apiKey" size="medium"></el-input>
            </template>
          </div>
        </el-checkbox>
      </el-checkbox-group>
      <el-button @click="stepTwoSubmit" v-loading="stepTwo.loading">{{$t('openShop.确定')}}</el-button>
    </div>
    <div class="step-3" v-if="stepThree.active">
      <div class="text-1">{{$t('openShop.以下是官方套餐推荐服务选择')}}：</div>
      <div class="text-2">{{$t('openShop.官方根据各个场景专业化推荐套餐')}}</div>
      <el-radio-group v-model="stepThree.result_1">
        <el-radio @click.native.prevent="handleStepThreeRadio(value.service_package_id)" :label="value.service_package_id" v-for="value in stepThree.data_1" :key="value.service_package_id">
          <div class="panel">
            <div class="checked-box">
              <el-image :src="value.service_package_image[0]" fit="cover"></el-image>
              <div class="title">
                <span>{{value.service_package_name}}</span>
                <span>NZD ${{(value.service_package_price / 100).toFixed(2)}}</span>
              </div>
              <div class="description">
                <!-- <span>{{$t('openShop.套餐介绍')}}：</span> -->
                <span>{{$t('openShop.每月')}}</span>
              </div>
            </div>
            <el-button @click="openDialog_1(value, 'result_1')">{{$t('openShop.查看介绍')}}</el-button>
          </div>
        </el-radio>
      </el-radio-group>
      <!-- <div class="text-1">{{$t('openShop.以下是个性化服务选择')}}：</div>
      <div class="text-2">{{$t('openShop.可根据自己店铺所需个性化定制')}}</div> -->
      <!-- <div class="wrap">
        <div class="title">
          <span>{{$t('openShop.POS系统')}}</span>
        </div>
        <el-checkbox-group v-model="stepThree.result_2">
          <el-checkbox :label="value.service_id" v-for="value in stepThree.data_2" :key="value.service_id" @change="handleStepThreeResultCheckBox(value, 'result_2')">
            <div class="panel">
              <div class="checked-box">
                <el-image :src="value.service_image[0]" fit="cover"></el-image>
                <div class="title">
                  <span></span>
                </div>
                <div class="description center">
                  <span>{{value.service_name}}</span>
                </div>
              </div>
              <el-button @click="openDialog_3(value, 'result_2')">{{$t('openShop.查看介绍')}}</el-button>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div> -->
      <!-- <div class="wrap">
        <div class="title">
          <span>{{$t('openShop.POS硬件机')}}</span>
        </div>
        <el-checkbox-group v-model="stepThree.result_3">
          <el-checkbox :label="value.service_id" v-for="value in stepThree.data_3" :key="value.service_id" @change="handleStepThreeResultCheckBox(value, 'result_3')">
            <div class="panel">
              <div class="checked-box">
                <el-image :src="value.service_image[0]" fit="cover"></el-image>
                <div class="title">
                  <span></span>
                </div>
                <div class="description center">
                  <span>{{value.service_name}}</span>
                </div>
              </div>
              <el-button @click="openDialog_3(value, 'result_3')">{{$t('openShop.查看介绍')}}</el-button>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div> -->
      <!-- <div class="wrap">
        <div class="title">
          <span>{{$t('openShop.网络服务')}}</span>
        </div>
        <el-checkbox-group v-model="stepThree.result_5">
          <el-checkbox :label="value.service_id" v-for="value in stepThree.data_5" :key="value.service_id" @change="handleStepThreeResultCheckBox(value, 'result_5')">
            <div class="panel">
              <div class="checked-box">
                <el-image :src="value.service_image[0]" fit="cover"></el-image>
                <div class="title">
                  <span></span>
                </div>
                <div class="description center">
                  <span>{{value.service_name}}</span>
                </div>
              </div>
              <el-button @click="openDialog_3(value, 'result_5')">{{$t('openShop.查看介绍')}}</el-button>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div> -->
      <!-- <div class="wrap">
        <div class="title">
          <span>{{$t('openShop.配件')}}</span>
        </div>
        <el-checkbox-group v-model="stepThree.result_6">
          <el-checkbox :label="value.service_id" v-for="value in stepThree.data_6" :key="value.service_id">
            <div class="panel">
              <div class="checked-box">
                <el-image :src="value.service_image[0]" fit="cover"></el-image>
                <div class="title">
                  <span></span>
                  <span>NZD ${{generatePrice(value.service_price)}}</span>
                </div>
                <div class="description center">
                  <span>{{$t('openShop.每月')}}</span>
                  <span>{{value.service_name}}</span>
                </div>
              </div>
              <el-button @click="openDialog_2(value, 'result_6')">{{$t('openShop.查看介绍')}}</el-button>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div> -->
      <el-button @click="stepThreeSubmit" :loading="stepThree.loading">{{$t('openShop.确定')}}</el-button>
    </div>
    <div class="step-4" v-if="stepFour.active">
      <template v-if="stepFour.data.offline_pay.length">
        <div class="item">
          <div class="title">{{$t('openShop.线下商品支付')}}</div>
          <div class="goods" v-for="value in stepFour.data.offline_pay" :key="value.progress_choose_id">
            <div class="left">
              <el-image :src="value.progress_choose_target.service_image[0]" fit="cover"></el-image>
              <span>{{value.progress_choose_target.service_name}}</span>
            </div>
            <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.service_price / 100).toFixed(2)}}</div>
          </div>
        </div>
        <div class="sum">{{$t('openShop.线下支付总价')}}：NZD ${{(stepFour.data.offlinePaySum / 100).toFixed(2)}}</div>
        <el-divider></el-divider>
      </template>
      <div class="item" v-if="stepFour.data.online_pay.MEMBER_PLAN.length">
        <div class="title">{{$t('openShop.已选套餐')}}</div>
        <div class="goods" v-for="value in stepFour.data.online_pay.MEMBER_PLAN" :key="value.progress_choose_id">
          <div class="left">
            <!-- <el-image :src="value.progress_choose_target.template_image[0]" fit="cover"></el-image> -->
            <div class="plan" :style="{background:getPlanColor(value.progress_choose_target.member_plan_name)}">{{value.progress_choose_target.member_plan_name}}</div>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.member_plan_price / 100).toFixed(2)}}</div>
        </div>
      </div>
      <div class="item" v-if="stepFour.data.online_pay.TEMPLATE.length">
        <div class="title">{{$t('openShop.已选模板')}}</div>
        <div class="goods" v-for="value in stepFour.data.online_pay.TEMPLATE" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.template_image[0]" fit="cover"></el-image>
            <span>{{value.progress_choose_target.template_name}}</span>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.template_price / 100).toFixed(2)}}</div>
        </div>
      </div>
      <div class="item" v-if="stepFour.data.online_pay.SHOP_PAYMENT.length">
        <div class="title">{{$t('openShop.绑定的支付渠道')}}</div>
        <div class="goods" v-for="value in stepFour.data.online_pay.SHOP_PAYMENT" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.shop_payment_icon" fit="cover"></el-image>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.shop_payment_price / 100).toFixed(2)}}</div>
        </div>
      </div>
      <div class="item" v-if="stepFour.data.online_pay.SERVICE_PACKAGE.length || stepFour.data.online_pay.SERVICE.length || stepFour.data.online_pay.SERVICE_MODEL">
        <div class="title">{{$t('openShop.已选商品')}}</div>
        <div class="goods" v-for="value in stepFour.data.online_pay.SERVICE_PACKAGE" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.service_package_image[0]" fit="cover"></el-image>
            <span>{{value.progress_choose_target.service_package_name}}</span>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.service_package_price / 100).toFixed(2)}}</div>
        </div>
        <div class="goods" v-for="value in stepFour.data.online_pay.SERVICE" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.service_image[0]" fit="cover"></el-image>
            <span>{{value.progress_choose_target.service_name}}</span>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.service_price / 100).toFixed(2)}}</div>
        </div>
        <div class="goods" v-for="value in stepFour.data.online_pay.SERVICE_MODEL" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.service_model_image[0]" fit="cover"></el-image>
            <span>{{value.progress_choose_target.service_model_name}}</span>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.service_model_price / 100).toFixed(2)}}</div>
        </div>
      </div>
      <div class="sum">{{$t('openShop.线上支付总价')}}：NZD ${{(stepFour.data.onlinePaySum / 100).toFixed(2)}}</div>
      <el-button @click="stepFourSubmit" :loading="stepFour.loading">{{$t('openShop.立即线上支付')}}</el-button>
    </div>
    <div class="step-5" v-if="stepFive.active">
      <i class="el-icon-success"></i>
      <span>{{$t('openShop.提交成功')}}</span>
      <el-button type="success" @click="goPage('Home')">{{$t('openShop.返回dashboard')}}</el-button>
    </div>
    <div class="dialog">
      <el-dialog class="dialog-one" :title="dialogOne.title" :visible.sync="dialogOne.show" width="40%" center destroy-on-close>
        <div class="description">{{$t('openShop.套餐介绍')}}：<span v-html="generateShopString(dialogOne.desc)"></span></div>
        <div class="item" v-for="value in dialogOne.data" :key="value.service_id">
          <el-image :src="value.service_image[0]" fit="cover"></el-image>
          <div class="wrap">
            <div>{{generateShopString(value.service_name_str)}}</div>
            <div v-html="generateShopString(value.service_desc)"></div>
          </div>
          <div class="price">NZD ${{(value.service_price / 100).toFixed(2)}}</div>
        </div>
        <div class="sum">{{$t('openShop.订阅费')}}：NZD ${{(dialogOne.fee / 100).toFixed(2)}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" plain @click="cancelDialogOne">{{$t('openShop.取消')}}</el-button>
          <el-button type="success" @click="confirmDialogOne">{{$t('openShop.确定使用')}}</el-button>
        </span>
      </el-dialog>
      <el-dialog class="dialog-two" :title="dialogTwo.title" :visible.sync="dialogTwo.show" width="40%" center destroy-on-close>
        <div class="description">{{$t('openShop.系统介绍')}}：<span v-html="dialogTwo.desc"></span></div>
        <el-carousel type="card" :autoplay="false">
          <el-carousel-item v-for="value in dialogTwo.data" :key="value">
            <el-image :src="value" fit="cover"></el-image>
          </el-carousel-item>
        </el-carousel>
        <div class="sum">{{$t('openShop.订阅费')}}：NZD ${{(dialogTwo.fee / 100).toFixed(2)}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" plain @click="cancelDialogTwo">{{$t('openShop.取消')}}</el-button>
          <el-button type="success" @click="confirmDialogTwo">{{$t('openShop.确定使用')}}</el-button>
        </span>
      </el-dialog>
      <el-dialog class="dialog-three" :title="dialogThree.title" :visible.sync="dialogThree.show" width="694px" center destroy-on-close @close="cancelDialogThree">
        <div class="description">{{$t('openShop.系统介绍')}}：<span v-html="dialogThree.desc"></span></div>
        <el-radio-group v-model="dialogThree.result">
          <el-radio :label="value.service_model_id" v-for="value in dialogThree.data" :key="value.service_model_id" @change="handleDialogThreeRadio(value)">
            <div class="panel">
              <el-image class="checked-box" :src="value.service_model_image[value.selectImgIndex]" fit="cover"></el-image>
              <div class="imgs" v-if="value.service_model_image.length > 1">
                <el-image :class="{'active': y === value.selectImgIndex}" v-for="(x, y) in value.service_model_image" :key="x" :src="x" fit="cover" @click="value.selectImgIndex = y"></el-image>
              </div>
              <div class="title">{{value.service_model_name}}</div>
            </div>
          </el-radio>
        </el-radio-group>
        <div class="sum">{{$t('openShop.订阅费')}}：NZD ${{(dialogThree.fee / 100).toFixed(2)}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" plain @click="cancelDialogThree">{{$t('openShop.取消')}}</el-button>
          <el-button type="success" @click="confirmDialogThree">{{$t('openShop.确定使用')}}</el-button>
        </span>
      </el-dialog>
      <el-dialog class="dialog-four" :title="dialogFour.title" :visible.sync="dialogFour.show" width="40%" center destroy-on-close>
        <span v-html="dialogFour.desc"></span>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" plain @click="dialogFour.show = false">{{$t('openShop.取消')}}</el-button>
          <el-button type="success" @click="dialogFour.show = false">{{$t('openShop.确定使用')}}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Logo from '@/views/layout/components/Logo.vue'
import { Navbar } from '@/views/layout/components'
import request from '@/utils/request'
import { step3data1 } from './stepThreedata1.js'
import { generateShopString } from '@/utils/i18n.js'

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkList: [],
      stepZero: {
        // response for step 1 of page
        active: false,
        complete: null,
        data: [
          { id: '1', desc: 'entry', price: '19.00' },
          { id: '2', desc: 'standard', price: '49.00' },
          { id: '3', desc: 'advanced', price: '99.00' },
          { id: '4', desc: 'Professional', price: '299.00' }
        ],
        result: [],
        loading: false
      },
      stepOne: {
        // response for step 2 of the page
        active: false,
        complete: false,
        data: [],
        result: null,
        loading: false
      },
      stepTwo: {
        // response for step 3 of the page
        active: false,
        complete: false,
        data: [],
        result: [],
        loading: false,
        iePay: {
          apiKey: null,
          mid: null
        }
      },
      stepThree: {
        // response for step 4 of the page
        active: false,
        complete: false,
        data_1: [],
        data_2: [],
        data_3: [],
        data_4: [],
        data_5: [],
        data_6: [],
        result_1: null,
        result_2: [],
        result_2_type: [],
        result_3: [],
        result_3_type: [],
        result_4: [],
        result_5: [],
        result_5_type: [],
        result_6: [],
        loading: false
      },
      stepFour: {
        // response for step 5 of the page
        active: false,
        complete: false,
        loading: false,
        data: {
          offline_pay: [],
          online_pay: {
            TEMPLATE: [],
            SHOP_PAYMENT: [],
            SERVICE_PACKAGE: [],
            SERVICE: []
          }
        }
      },
      stepFive: {
        // response for step 6 of the page
        active: false
      },
      dialogOne: {
        title: null,
        id: null,
        desc: null,
        fee: 0,
        show: false,
        keyword: null,
        data: []
      },
      dialogTwo: {
        title: null,
        id: null,
        desc: null,
        fee: 0,
        show: false,
        keyword: null,
        data: []
      },
      dialogThree: {
        title: null,
        id: null,
        desc: null,
        fee: 0,
        show: false,
        keyword: null,
        data: [],
        result: null
      },
      dialogFour: {
        title: null,
        desc: null,
        show: false
      }
    }
  },
  components: {
    Logo,
    Navbar
  },
  mounted() {
    if (this.isShow) {
      this.initStep()
    } else {
      const step = this.$route.query.step
      this.checkStep().then(() => {
        if (!this.stepZero.complete) {
          this.switchTab(this.stepZero)
        } else if (!this.stepOne.complete) {
          this.switchTab(this.stepOne)
        } else if (!this.stepTwo.complete) {
          this.switchTab(this.stepTwo)
        } else if (!this.stepThree.complete) {
          this.switchTab(this.stepThree)
        } else if (!this.stepFour.complete) {
          this.initStepFour()
          this.switchTab(this.stepFour)
        } else {
          this.switchTab(this.stepFive)
        }
        if (this[step] && !this.stepFour.complete) {
          this.switchTab(this[step])
        }
      })
      this.initInfo()
    }
  },
  methods: {
    generateShopString,
    goPage(name) {
      this.$router.push({
        name
      })
    },
    getPlanColor(plan_name) {
      if (plan_name) {
        if (plan_name == 'Entry') {
          return '#DdA02F'
        } else if (plan_name == 'Standard') {
          return '#bfad6f'
        } else if (plan_name == 'Advanced') {
          return '#dab273'
        } else if (plan_name == 'Professional') {
          return '#ba6e40'
        } else return 'grey'
      } else return 'grey'
    },
    checkStep() {
      return this.$store.dispatch('SetOpenShopStepInfo').then(() => {
        this.initStep()
      })
    },
    initStep() {
      this.stepZero.complete = this.$store.state.shop.open_shop_step_info.step_member_plan_complete
      this.stepOne.complete = this.$store.state.shop.open_shop_step_info.step_template_complete
      this.stepTwo.complete = this.$store.state.shop.open_shop_step_info.step_shop_payment_complete
      this.stepThree.complete = this.$store.state.shop.open_shop_step_info.step_service_complete
      this.stepFour.complete = this.$store.state.shop.open_shop_step_info.step_progress_complete
    },
    initInfo() {
      request({
        url: '/progress/choose/compose',
        method: 'get'
      }).then(res => {
        this.stepZero.data = res.data.step_member_plan_data.data
        this.stepZero.result = this.getRadioResult(res.data.step_member_plan_data.data, 'member_plan_id')
        this.stepOne.data = res.data.step_template_data.data
        this.stepTwo.data = res.data.step_shop_payment_data.data
        this.stepThree.data_1 = step3data1
        // this.stepThree.data_1 = res.data.step_service_data.service_package_data.data
        this.stepThree.data_2 = res.data.step_service_data.service_pos_system_data.data.filter(val => val.service_is_show)
        this.stepThree.data_3 = res.data.step_service_data.service_pos_hardware_data.data.filter(val => val.service_is_show)
        this.stepThree.data_4 = res.data.step_service_data.service_efpos_system_data.data.filter(val => val.service_is_show)
        this.stepThree.data_5 = res.data.step_service_data.service_internet_service_data.data.filter(val => val.service_is_show)
        this.stepThree.data_6 = res.data.step_service_data.service_consumables_data.data.filter(val => val.service_is_show)
        this.stepOne.result = this.getRadioResult(res.data.step_template_data.data, 'template_id')

        // this.stepOne.result = res.data.step_template_data.data.filter(val => val.is_choose).map(val => val.template_id)
        const stepTwoResult = res.data.step_shop_payment_data.data.filter(val => val.is_choose)
        stepTwoResult.forEach(value => {
          if (value.shop_payment_type === 'IEPAY') {
            this.stepTwo.iePay.apiKey = value.shop.my_pay_api_key
            this.stepTwo.iePay.mid = value.shop.my_pay_mid
          }
        })
        this.stepTwo.result = stepTwoResult.map(val => val.shop_payment_id)
        this.stepThree.result_1 = this.getRadioResult(res.data.step_service_data.service_package_data.data, 'service_package_id')
        // this.stepThree.result_1 = res.data.step_service_data.service_package_data.data.filter(val => val.is_choose).map(val => val.service_package_id)
        const posSystem = res.data.step_service_data.service_pos_system_data.data.filter(val => val.is_choose)
        const posSystemType = []
        posSystem.forEach(value => {
          posSystemType.push(value.service_model.filter(val => val.is_choose)[0].service_model_id)
        })
        this.stepThree.result_2 = posSystem.map(val => val.service_id)
        this.stepThree.result_2_type = posSystemType
        const posHardware = res.data.step_service_data.service_pos_hardware_data.data.filter(val => val.is_choose)
        const posHardwareType = []
        posHardware.forEach(value => {
          posHardwareType.push(value.service_model.filter(val => val.is_choose)[0].service_model_id)
        })
        this.stepThree.result_3 = posHardware.map(val => val.service_id)
        this.stepThree.result_3_type = posHardwareType
        this.stepThree.result_4 = res.data.step_service_data.service_efpos_system_data.data.filter(val => val.is_choose).map(val => val.service_id)
        const internetService = res.data.step_service_data.service_internet_service_data.data.filter(val => val.is_choose)
        const internetServiceType = []
        internetService.forEach(value => {
          internetServiceType.push(value.service_model.filter(val => val.is_choose)[0].service_model_id)
        })
        this.stepThree.result_5 = internetService.map(val => val.service_id)
        this.stepThree.result_5_type = internetServiceType
        this.stepThree.result_6 = res.data.step_service_data.service_consumables_data.data.filter(val => val.is_choose).map(val => val.service_id)
      })
    },
    openDialog_1(data, keyword) {
      this.dialogOne.title = data.service_package_name
      this.dialogOne.id = data.service_package_id
      this.dialogOne.desc = data.service_package_desc
      this.dialogOne.data = data.service
      this.dialogOne.fee = data.service_package_price
      this.dialogOne.keyword = keyword
      this.dialogOne.show = true
    },
    handleStepThreeRadio(val) {
      if (this.stepThree.result_1 == val) {
        this.stepThree.result_1 = null
        return
      }
      this.stepThree.result_1 = val
    },
    openDialog_2(data, keyword) {
      this.dialogTwo.title = data.service_name
      this.dialogTwo.id = data.service_id
      this.dialogTwo.desc = data.service_desc
      this.dialogTwo.data = data.service_image
      this.dialogTwo.fee = data.service_price
      this.dialogTwo.keyword = keyword
      this.dialogTwo.show = true
    },
    generatePrice(price) {
      return (price / 100).toFixed(2)
    },
    openDialog_3(data, keyword) {
      this.dialogThree.title = data.service_name
      this.dialogThree.id = data.service_id
      this.dialogThree.desc = data.service_desc
      this.dialogThree.data = data.service_model.map(val => {
        this.$set(val, 'selectImgIndex', 0)
        return val
      })
      this.dialogThree.fee = data.service_model.filter(val => val.is_choose).length ? data.service_model.filter(val => val.is_choose)[0].service_model_price : 0
      this.dialogThree.keyword = keyword
      this.dialogThree.result = data.service_model.filter(val => val.is_choose).length ? data.service_model.filter(val => val.is_choose)[0].service_model_id : null
      this.dialogThree.show = true
    },
    getRadioResult(resData = [], returnIdRes, chooseRes = 'is_choose') {
      // returnIdRes comes from backend  id's variable name
      const i = resData.findIndex((item) => item[chooseRes] == true)
      if (i > -1) {
        return resData[i][returnIdRes]
      } else return null
    },
    handleDialogThreeRadio(data) {
      this.dialogThree.fee = data.service_model_price
    },
    cancelDialogOne() {
      this.dialogOne = {
        title: null,
        id: null,
        desc: null,
        fee: null,
        show: false,
        keyword: null,
        data: []
      }
    },
    cancelDialogTwo() {
      this.dialogTwo = {
        title: null,
        id: null,
        desc: null,
        fee: null,
        show: false,
        keyword: null,
        data: []
      }
    },
    cancelDialogThree() {
      const typeData = this.stepThree[`${this.dialogThree.keyword}_type`]
      this.dialogThree.data.forEach(value => {
        value.is_choose = value.service_model_id === this.dialogThree.result
        const typeIndex = typeData.indexOf(value.service_model_id)
        if (value.is_choose) {
          if (typeIndex) {
            typeData.push(this.dialogThree.result)
          }
        } else {
          if (typeIndex > -1) {
            typeData.splice(typeIndex, 1)
          }
        }
      })
      if (!this.dialogThree.result) {
        this.stepThree[this.dialogThree.keyword].splice(this.stepThree[this.dialogThree.keyword].indexOf(this.dialogThree.id), 1)
      }
      this.dialogThree = {
        title: null,
        id: null,
        desc: null,
        fee: null,
        show: false,
        keyword: null,
        data: [],
        result: null
      }
    },
    confirmDialogOne() {
      this.stepThree[this.dialogOne.keyword] = this.dialogOne.id
      // const index = data.indexOf(this.dialogOne.id)
      // if (index === -1) {
      //   data.push(this.dialogOne.id)
      // }
      this.cancelDialogOne()
    },
    confirmDialogTwo() {
      const data = this.stepThree[this.dialogTwo.keyword]
      const index = data.indexOf(this.dialogTwo.id)
      if (index === -1) {
        data.push(this.dialogTwo.id)
      }
      this.cancelDialogTwo()
    },
    confirmDialogThree() {
      this.dialogThree.show = false
    },
    goTab(name) {
      if (!this.stepFour.complete && !this.isShow) {
        this.switchTab(this[name])
      }
      this.$emit('goTab', name)
    },
    switchTab(data) {
      this.stepZero.active = false
      this.stepOne.active = false
      this.stepTwo.active = false
      this.stepThree.active = false
      this.stepFour.active = false
      this.stepFive.active = false
      data.active = !data.active
    },
    handleStepThreeResultCheckBox(data, keyword) {
      const hasChoose = !!data.service_model.filter(val => val.is_choose).length
      if (hasChoose) {
        data.service_model.forEach(val => {
          val.is_choose = false
        })
        data.service_model.map(val => val.service_model_id).forEach(val => {
          const index = this.stepThree[`${keyword}_type`].indexOf(val)
          if (index > -1) {
            this.stepThree[`${keyword}_type`].splice(index, 1)
          }
        })
      } else {
        this.openDialog_3(data, keyword)
      }
    },
    stepZeroSubmit() {
      this.stepZero.loading = true
      request({
        url: '/progress/choose/step/memberPlan',
        method: 'post',
        data: {
          member_plan_choose_data: {
            MEMBER_PLAN: [this.stepZero.result]
          }
        }
      }).then(res => {
        this.checkStep()
        this.switchTab(this.stepOne)
      }).finally(() => {
        this.stepZero.loading = false
      })
    },
    stepOneSubmit() {
      this.stepOne.loading = true
      request({
        url: '/progress/choose/step/template',
        method: 'post',
        data: {
          template_choose_data: {
            TEMPLATE: this.stepOne.result == null ? [] : [this.stepOne.result]
          }
        }
      }).then(res => {
        this.checkStep()
        this.switchTab(this.stepTwo)
      }).finally(() => {
        this.stepOne.loading = false
      })
    },
    formatStepTwoParams() {
      return this.stepTwo.data.filter(val => this.stepTwo.result.indexOf(val.shop_payment_id) > -1).map(val => {
        const bind_data = {
          type: val.shop_payment_type
        }
        if (val.shop_payment_type === 'IEPAY') {
          bind_data.my_pay_api_key = this.stepTwo.iePay.apiKey
          bind_data.my_pay_mid = this.stepTwo.iePay.mid
        }
        return {
          progress_choose_target_id: val.shop_payment_id,
          progress_choose_target_type: 'SHOP_PAYMENT',
          bind_data
        }
      })
    },
    stepTwoSubmit() {
      this.stepTwo.loading = true
      request({
        url: '/progress/choose/step/shopPayment',
        method: 'post',
        data: {
          shop_payment_choose_data: this.formatStepTwoParams()
        }
      }).then(res => {
        this.checkStep()
        this.switchTab(this.stepThree)
      }).finally(() => {
        this.stepTwo.loading = false
      })
    },
    stepThreeSubmit() {
      this.stepThree.loading = true
      request({
        url: '/progress/choose/step/service',
        method: 'post',
        data: {
          service_choose_data: {
            SERVICE_PACKAGE: this.stepThree.result_1 == null ? [] : [this.stepThree.result_1],
            SERVICE: [
              ...this.stepThree.result_2,
              ...this.stepThree.result_3,
              ...this.stepThree.result_4,
              ...this.stepThree.result_5,
              ...this.stepThree.result_6
            ],
            SERVICE_MODEL: [
              ...this.stepThree.result_2_type,
              ...this.stepThree.result_3_type,
              ...this.stepThree.result_5_type
            ]
          }
        }
      }).then(res => {
        this.checkStep().then(() => {
          if (this.stepZero.complete && this.stepOne.complete && this.stepTwo.complete) {
            this.initStepFour()
            this.switchTab(this.stepFour)
          } else {
            this.$message.error('还有未正确填写的选项')
          }
        })
      }).finally(() => {
        this.stepThree.loading = false
      })
    },
    initStepFour() {
      request({
        url: '/progress/choose',
        method: 'get'
      }).then(res => {
        let offlinePaySum = 0
        res.data.offline_pay.forEach(value => {
          offlinePaySum = this.add(value.progress_choose_target.service_price, offlinePaySum)
        })
        res.data.offlinePaySum = offlinePaySum
        let onlinePaySum = 0
        res.data.online_pay.MEMBER_PLAN.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.member_plan_price, onlinePaySum)
        })
        res.data.online_pay.TEMPLATE.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.template_price, onlinePaySum)
        })
        res.data.online_pay.SERVICE_PACKAGE.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.service_package_price, onlinePaySum)
        })
        res.data.online_pay.SERVICE.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.service_price, onlinePaySum)
        })
        res.data.online_pay.SERVICE_MODEL.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.service_model_price, onlinePaySum)
        })
        res.data.online_pay.SHOP_PAYMENT.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.shop_payment_price, onlinePaySum)
        })
        res.data.onlinePaySum = onlinePaySum
        this.stepFour.data = res.data
      })
    },
    stepFourSubmit() {
      this.stepFour.loading = true
      request({
        url: '/progress/submit',
        method: 'post'
      }).then(res => {
        this.checkStep()
        this.switchTab(this.stepFive)
      }).finally(() => {
        this.stepFour.loading = false
      })
    },
    add(num1, num2) {
      let baseNum1
      let baseNum2
      try {
        baseNum1 = num1.toString().split('.')[1].length
      } catch (e) {
        baseNum1 = 0
      }
      try {
        baseNum2 = num2.toString().split('.')[1].length
      } catch (e) {
        baseNum2 = 0
      }
      const baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
      return (num1 * baseNum + num2 * baseNum) / baseNum
    },
    openDialog_4(data) {
      this.dialogFour.title = this.$t('openShop.配置说明')
      this.dialogFour.desc = data.shop_payment_desc
      this.dialogFour.show = true
    }
  }
}
</script>

<style lang="less" scoped>
  .open-shop {
    .nav-wrap {
      display: flex;
      .logo {
        width: 180px;
      }
      .navbar {
        flex: 1;
      }
    }
    .step {
      margin-top: 56px;
      .number {
        width: 50%;
        display: flex;
        align-items: center;
        margin: 0 auto;
        & > div {
          transition: all .3s;
          &:nth-of-type(2n) {
            flex: 1;
            background-color: rgba(0, 0, 0, .15);
            height: 1px;
            margin: 0 16px;
            &.active {
              background-color: #96BF47;
            }
          }
          &:nth-of-type(2n+1) {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            color: rgba(0, 0, 0, .25);
            border: 1px solid rgba(0, 0, 0, .15);
            font-size: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &.active {
              background-color: #96BF47;
              color: #ffffff;
              border-color: #96BF47;
            }
          }
        }
      }
      .text {
        width: 57%;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        text-align: center;
        margin-top: 10px;
        & > div {
          flex: 1;
          color: rgba(0, 0, 0, .45);
          transition: all .3s;
          &.active {
            color: #000000;
            font-weight: bold;
          }
        }
      }
    }
    .step-0 .el-radio:nth-child(1) .el-radio__label .panel .top-img {
      background: #DdA02F;
    }
    .step-0 .el-radio:nth-child(2) .el-radio__label .panel .top-img::before {
      content: 'Most Popluar';
      position: absolute;
      top: 5px;
      text-align: center;
      line-height: 24px;
      left: calc(50% - 50px);
      color: purple;
      width: 100px;
      height: 24px;
      font-weight: bold;
      background: white;
      border-radius: 4px;
    }
    .step-0 .el-radio:nth-child(2) .el-radio__label .panel .top-img {
      background: #bfad6f;
    }
    .step-0 .el-radio:nth-child(3) .el-radio__label .panel .top-img {
      background: #dab273;
    }.step-0 .el-radio:nth-child(4) .el-radio__label .panel .top-img {
      background: #ba6e40;
    }
    .step-0,
    .step-1,
    .step-2,
    .step-3,
    .step-4,
    .step-5 {
      width: 60%;
      margin: 48px auto 0 auto;
      & > .el-button {
        min-width: 110px;
        margin: 48px auto;
        border: none;
        background-color: #96BF47;
        color: #ffffff;
        padding: 13px 20px;
        display: block;
        border-radius: 20px;
      }
    }
    .step-0 {
      .top-img {
        height: 208px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        background: rgb(186, 110, 64);
        border-radius: 20px;
        overflow: hidden;
        position: relative;
      }
      .panel {
        width: 250px;
        min-height: 508px;
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
        border-radius: 20px;
        overflow: hidden;
        .content {
          padding: 10px;
          line-height: 25px;
        }
      }
    }
    .step-1 {
      .panel {
        width: 268px;
        overflow: hidden;
        .text-1 {
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          text-align: center;
          margin: 32px 24px 0 24px;
        }
        & > .el-image {
          margin: 24px 24px 0 24px;
        }
        .text-2 {
          font-size: 14px;
          line-height: 22px;
          color: rgba(0, 0, 0, .45);
          border-bottom: 1px solid #E8E8E8;
          margin: 0 24px;
          padding: 8px 0;
          word-break: break-all;
        }
        .imgs {
          display: flex;
          height: 68px;
          margin: 8px 24px;
          .el-image {
            flex: 1;
            &:not(:last-of-type) {
              margin-right: 8px;
            }
          }
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 24px;
          background-color: #F7F7F7;
          height: 48px;
          font-size: 14px;
          border-bottom-left-radius: 16px;
          border-bottom-right-radius: 16px;
          color: #FBA718;
        }
      }
    }
    .step-2 {
      .el-checkbox-group {
        align-items: initial;
      }
      .panel {
        width: 160px;
        text-align: center;
        .el-image {
          height: 160px;
        }
        .title {
          font-weight: bold;
          color: #96BF47;
          margin: 24px 0;
          font-size: 20px;
        }
        .el-button {
          margin-bottom: 24px;
        }
        .el-input {
          & + .el-input {
            margin-top: 12px;
          }
        }
      }
    }
    .step-3 {
      .text-1 {
        font-size: 20px;
        color: #96BF47;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .text-2 {
        font-size: 14px;
        color: #96BF47;
        margin-bottom: 32px;
      }
      .el-checkbox-group {
        &:not(:last-of-type) {
          margin-bottom: 56px;
        }
      }
      .panel {
        width: 240px;
        .el-image {
          height: 210px;
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
        }
        .title {
          padding: 15px 20px 8px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-weight: bold;
            &:nth-of-type(1) {
              font-size: 20px;
              color: rgba(0, 0, 0, .85);
            }
            &:nth-of-type(2) {
              font-size: 16px;
              color: #FBA718;
            }
          }
        }
        .description {
          padding: 0 20px 15px 20px;
          display: flex;
          flex-direction: column;
          color: rgba(0, 0, 0, .45);
          font-size: 14px;
          word-break: break-all;
          &.center {
            text-align: center;
          }
        }
        .el-button {
          width: 110px;
          height: 40px;
          background-color: rgba(150, 191, 71, .15);
          color: #96BF47;
          border-radius: 20px;
          border: none;
          margin: 24px auto 0 auto;
          display: block;
        }
      }
      .wrap {
        display: flex;
        align-items: center;
        &:not(:last-of-type) {
          margin-bottom: 40px;
        }
        & > .title {
          display: flex;
          flex-direction: column;
          width: 160px;
          flex-shrink: 0;
          span {
            font-weight: bold;
            &:nth-of-type(1) {
              color: rgba(0, 0, 0, .85);
              font-size: 20px;
            }
            &:nth-of-type(2) {
              color: #F5222D;
              font-size: 14px;
            }
          }
        }
        .panel {
          width: 200px;
          .title {
            justify-content: center;
          }
        }
      }
    }
    .step-4 {
      .item {
        margin-bottom: 32px;
        .plan {
          width: 12rem;
          height: 7rem;
          text-align: center;
          line-height: 7rem;
          overflow: hidden;
          border-radius: 1rem;
          font-size: 1.5rem;
          color: white;
          font-weight: bolder;
        }
        .title {
          font-size: 24px;
          color: #96BF47;
          font-weight: bold;
          margin-bottom: 24px;
        }
        .goods {
          display: flex;
          align-items: center;
          justify-content: space-between;
          &:not(:last-of-type) {
            margin-bottom: 16px;
          }
          .left {
            display: flex;
            align-items: center;
            font-size: 14px;
            .el-image {
              width: 120px;
              height: 90px;
              border-radius: 4px;
              margin-right: 16px;
            }
          }
          .right {
            font-size: 14px;
            color: #FBA718;
          }
        }
      }
      .sum {
        text-align: right;
        font-size: 20px;
        color: #FBA718;
      }
    }
    .step-5 {
      text-align: center;
      i {
        font-size: 72px;
        color: #4DCB73;
        display: block;
        margin-bottom: 24px;
      }
      span {
        font-size: 24px;
        color: rgba(0, 0, 0, .85);
        font-weight: bold;
      }
    }
  }
  .el-image {
    display: block;
  }
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -32px;
  }
 /deep/ .el-checkbox {
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: initial;
    margin: 10px 32px;
    .el-checkbox__input {
      &.is-checked {
        &+.el-checkbox__label {
          color: initial;
          .checked-box {
            &::before {
              border-color: #96BF47;
            }
          }
        }
        .el-checkbox__inner {
          background-color: #96BF47;
          border-color: #96BF47;
        }
      }
      &:hover,
      &.is-focus {
        .el-checkbox__inner {
          border-color: #96BF47;
        }
      }
    }
    .el-checkbox__label {
      font-weight: initial;
      padding-left: 0;
      margin-top: 24px;
      .checked-box {
        box-shadow: 0 0 12px 1px rgba(0, 0, 0, .1);
        border-radius: 16px;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 1px solid transparent;
          border-radius: 16px;
          transition: all .3s;
        }
      }
    }
  }
  .el-radio-group {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -32px;
    justify-content: space-evenly;
    // overflow: auto;
  }
  .el-radio-group /deep/ .el-radio {
    // width: calc(100% - 418px);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px 5px;
    white-space: initial;
    .el-radio__input {
      &.is-checked {
        &+.el-radio__label {
          color: #96BF47;
          .checked-box {
            &::before {
              border-color: #96BF47;
            }
          }
        }
        .el-radio__inner {
          background-color: #96BF47;
          border-color: #96BF47;
        }
      }
      &:hover,
      &.is-focus {
        .el-radio__inner {
          border-color: #96BF47;
        }
      }
    }
    .el-radio__label {
      font-weight: initial;
      padding-left: 0;
      margin-top: 24px;
      .checked-box {
        box-shadow: 0 0 12px 1px rgba(0, 0, 0, .1);
        border-radius: 20px;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 1px solid transparent;
          border-radius: 20px;
          transition: all .3s;
        }
      }
    }
  }
  .dialog /deep/ .el-radio {
    width: calc(100% - 418px);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px 32px;
    white-space: initial;
    .el-radio__input {
      &.is-checked {
        &+.el-radio__label {
          color: initial;
          .checked-box {
            &::before {
              border-color: #96BF47;
            }
          }
        }
        .el-radio__inner {
          background-color: #96BF47;
          border-color: #96BF47;
        }
      }
      &:hover,
      &.is-focus {
        .el-radio__inner {
          border-color: #96BF47;
        }
      }
    }
    .el-radio__label {
      font-weight: initial;
      padding-left: 0;
      margin-top: 24px;
      .checked-box {
        box-shadow: 0 0 12px 1px rgba(0, 0, 0, .1);
        border-radius: 16px;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 1px solid transparent;
          border-radius: 16px;
          transition: all .3s;
        }
      }
    }
  }

  .dialog-one {
    .description {
      color: rgba(0, 0, 0, .65);
      font-size: 14px;
      margin-bottom: 24px;
      word-break: break-all;
    }
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .el-image {
        width: 80px;
        height: 60px;
        border-radius: 8px;
      }
      .wrap {
        flex: 1;
        margin: 0 24px 0 16px;
        & > div {
          &:nth-of-type(1) {
            color: rgba(0, 0, 0, .85);
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 8px;
          }
          &:nth-of-type(2) {
            color: rgba(0, 0, 0, .45);
            font-size: 14px;
            word-break: break-all;
          }
        }
      }
      .price {
        font-size: 16px;
        color: #FBA718;
      }
    }
    .sum {
      font-size: 20px;
      color: #FBA718;
      text-align: right;
    }
  }
  .dialog-two {
    .description {
      color: rgba(0, 0, 0, .65);
      font-size: 14px;
      margin-bottom: 24px;
      word-break: break-all;
    }
    /deep/ .el-carousel {
      .el-carousel__container {
        height: 230px;
        .el-image {
          height: 100%;
          border-radius: 8px;
        }
      }
    }
    .sum {
      font-size: 20px;
      color: #FBA718;
      text-align: right;
    }
  }
  .dialog-three {
    .description {
      color: rgba(0, 0, 0, .65);
      font-size: 14px;
      margin-bottom: 24px;
      word-break: break-all;
    }
    .el-radio-group {
      .el-radio {
        .panel {
          .checked-box {
            height: 160px;
            margin-bottom: 4px;
            border-radius: 8px;
            box-shadow: initial;
            &::before {
              border-radius: 8px;
            }
          }
          .imgs {
            display: flex;
            .el-image {
              width: calc(20% - 2px);
              height: 40px;
              border-radius: 8px;
              opacity: .4;
              &.active {
                opacity: 1;
              }
              &:not(:last-of-type) {
                margin-right: 4px;
              }
            }
          }
          .title {
            font-size: 16px;
            color: rgba(0, 0, 0, .85);
            text-align: center;
            margin-top: 16px;
            font-weight: bold;
          }
        }
      }
    }
    .sum {
      font-size: 20px;
      color: #FBA718;
      text-align: right;
    }
  }
</style>
